import { render, staticRenderFns } from "./TotalCfg.vue?vue&type=template&id=a3fdf14a&scoped=true"
import script from "./TotalCfg.vue?vue&type=script&lang=js"
export * from "./TotalCfg.vue?vue&type=script&lang=js"
import style0 from "./TotalCfg.vue?vue&type=style&index=0&id=a3fdf14a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fdf14a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\cxy\\project\\zcy\\zcy-dataEase\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3fdf14a')) {
      api.createRecord('a3fdf14a', component.options)
    } else {
      api.reload('a3fdf14a', component.options)
    }
    module.hot.accept("./TotalCfg.vue?vue&type=template&id=a3fdf14a&scoped=true", function () {
      api.rerender('a3fdf14a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chart/components/shapeAttr/TotalCfg.vue"
export default component.exports